import type {
  PaginatedNoSearchQuery,
  PaginatedPeriodQuery,
  PaginatedQuery
} from '@/types/services/utils/request.type.ts';

export function buildQuery(params: PaginatedQuery): string {
  const query = new URLSearchParams()

  query.set('search', params.search)
  query.set('sort', params.sort)
  query.set('order', params.order)
  query.set('limit', String(params.limit ?? 10))
  query.set('page',  String(params.page ?? 1))

  return query.toString()
}

export function buildNoSearchQuery(params: PaginatedNoSearchQuery): string {
  const query = new URLSearchParams()

  query.set('sort', params.sort)
  query.set('order', params.order)
  query.set('limit', String(params.limit ?? 10))
  query.set('page',  String(params.page ?? 1))

  return query.toString()
}

export function buildPeriodQuery(params: PaginatedPeriodQuery): string {
  const query = new URLSearchParams()

  query.set('sort', params.sort)
  query.set('order', params.order)
  query.set('limit', String(params.limit ?? 10))
  query.set('page',  String(params.page ?? 1))
  query.set('period', params.period)

  return query.toString()
}
